import styled from "styled-components";
import NumberInput from "../NumberInput";
import NumberInputNoSpinner from "../NumberInputNoSpinner";

const StyledFormNumberInputNoSpinner = styled.div`
    display: block;
    padding-top: 15px;
    align-items: center;

    input {
        padding: 6px 3px 6px 12px;
        height: 30px;
        font-size: 11px;
        font-weight: 400;
    }
`;

const LabelRegular = styled.div`
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 5px;
`;

const FormInputWithSuffix = styled.div`
    display: flex;
    align-items: center;
`;

const LabelSuffix = styled.div`
    font-size: 11px;
    font-weight: 400;
    padding-left: 12px;
    color: ${(props) => props.theme.color.dark};
`;

function FormNumberInputNoSpinner(props) {

    const {label, value, suffix, onChange, inputStyle, disabled, validated, min, onPressEnter, ...restProps} = props;

    return (
        <StyledFormNumberInputNoSpinner {...restProps}>
            <LabelRegular>{label}</LabelRegular>
            <FormInputWithSuffix>
                <NumberInputNoSpinner value={value} onChange={(e) => onChange(parseInt(isNaN(e.target.value) ? 0 : e.target.value))} onPressEnter={onPressEnter} disabled={disabled} validated={validated} min={min} style={inputStyle}></NumberInputNoSpinner>
                {suffix && <LabelSuffix>{suffix}</LabelSuffix>}
            </FormInputWithSuffix>
        </StyledFormNumberInputNoSpinner>
    )
}

export default FormNumberInputNoSpinner;